import { ALBA_PRIVACY_POLICY_CONTENT } from '@/shared/constants/alba-privacy-policy-content.constants';
import { Dialog, Text } from '@noorden-insurtech/alba-design-system';

interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function PrivacyPolicyModal({ isOpen, onClose }: PrivacyPolicyModalProps) {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={details => {
        if (!details.open) onClose();
      }}
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content className='w-[580px] max-w-[95vw] rounded-[24px] bg-alba-white-500 p-8 shadow-xl'>
          <div className='flex max-h-[75vh] flex-col gap-6'>
            <Dialog.Header className='w-full shrink-0 p-0'>
              <Dialog.Title className='w-full'>
                <div className='flex w-full items-start justify-between gap-3'>
                  <Text className='text-2xl font-semibold leading-normal text-alba-black-500'>
                    Política de privacidade
                  </Text>
                  <Dialog.CloseTrigger asChild>
                    <Dialog.CloseButton />
                  </Dialog.CloseTrigger>
                </div>
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body className='max-h-[55vh] w-full overflow-y-auto p-0 pr-2'>
              <Text className='whitespace-pre-wrap text-base leading-normal text-alba-black-500'>
                {ALBA_PRIVACY_POLICY_CONTENT}
              </Text>
            </Dialog.Body>
          </div>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
